import { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

import AuthLayout from './_layout';

const CallbackPage = lazy(() => import('./callback'));
const LoginPage = lazy(() => import('./login'));
const LogoutPage = lazy(() => import('./logout'));
const VerifyPage = lazy(() => import('./verify'));

export const authRoutes: RouteObject[] = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
        handle: { breadcrumb: 'Sign In' },
      },
      {
        path: '/logout',
        element: <LogoutPage />,
        handle: { breadcrumb: 'Sign Out' },
      },
      {
        path: '/verify',
        element: <VerifyPage />,
        handle: { breadcrumb: 'Verify' },
      },
      { path: '/auth/callback/:provider', element: <CallbackPage /> },
    ],
  },
];
